
(() => {
  'use strict';
  if (window.homeThingsPreviewInitialised) return;
  window.homeThingsPreviewInitialised = true;
  // Demonstration only: no checkout endpoints, network calls, persistent storage or customer data.
  const PRICE_CENTS = 4495;
  const MAX_PREVIEW_QUANTITY = 10;
  let selectedQuantity = 1;
  let bagQuantity = 0;
  let lastTrigger = null;
  const money = cents => 'A$' + (cents / 100).toFixed(2);
  const $ = selector => document.querySelector(selector);
  const say = text => { const el = $('[data-announcement]'); if (el) el.textContent = text; };
  const info = {
    contact: ['Contact Home Things Co.', 'For customer and supplier enquiries, email support@homethingsco.com.au.', 'Our store is preparing to launch. Orders are not open yet.'],
    delivery: ['Delivery & returns', 'Delivery prices, dispatch estimates and serviceable postcodes are not confirmed. This draft does not accept orders.', 'Returns and customer-support arrangements must be finalised before selling. This preview text is not a completed returns policy.'],
    privacy: ['Privacy', 'This preview is hosted by Shopify, which may use cookies and process technical information to operate the storefront. The demonstration bag exists only in page memory and resets on refresh.', 'Orders and newsletter sign-ups are not open. Our full privacy policy will be published before launch.']
  };
  function openDialog(dialog, trigger) {
    if (!dialog) return;
    lastTrigger = trigger || document.activeElement;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else { say('Your browser needs an update to display this preview panel.'); }
  }
  function renderBag() {
    document.querySelectorAll('[data-bag-count]').forEach(el => { el.textContent = String(bagQuantity); });
    const total = $('[data-cart-total]'); if (total) total.textContent = money(bagQuantity * PRICE_CENTS);
    const content = $('[data-cart-content]'); if (!content) return;
    if (!bagQuantity) {
      content.innerHTML = '<div class="empty-cart"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" aria-hidden="true"><path d="M5 7h14l1 14H4L5 7Z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg><h3>Your bag is waiting.</h3><p>Try adding our first find. This is a preview, not a real order.</p><button type="button" class="button button-primary" data-explore>Explore the first find</button></div>';
      return;
    }
    content.innerHTML = '<div class="cart-row"><img data-cart-image width="100" height="100" alt="Illustration of grey sheet organisers"><div><h3 class="cart-title">Bed-sheet organiser set</h3><p class="cart-desc">4 pieces · Grey · Candidate product</p><p class="cart-price">' + money(PRICE_CENTS) + ' <span class="cart-desc">each, proposed</span></p><div class="cart-controls"><div class="quantity" role="group" aria-label="Preview bag quantity"><button type="button" data-bag-change="decrease" aria-label="Decrease bag quantity">−</button><span aria-live="polite">' + bagQuantity + '</span><button type="button" data-bag-change="increase" aria-label="Increase bag quantity">+</button></div><button type="button" class="remove-button" data-remove>Remove</button></div></div></div>';
    const img = $('[data-cart-image]');
    const gallery = $('[data-gallery-src]');
    if (img && gallery) img.src = gallery.dataset.gallerySrc;
  }
  document.addEventListener('click', event => {
    const target = event.target.closest('button, a');
    if (!target) return;
    if (target.hasAttribute('data-open-bag')) { renderBag(); openDialog($('#preview-bag'), target); }
    if (target.hasAttribute('data-open-menu')) openDialog($('#navigation-dialog'), target);
    if (target.hasAttribute('data-close-dialog')) target.closest('dialog')?.close();
    if (target.hasAttribute('data-mobile-link')) target.closest('dialog')?.close();
    if (target.dataset.gallerySrc) {
      const image = $('[data-main-image]');
      if (image) { image.src = target.dataset.gallerySrc; image.alt = target.dataset.galleryAlt || 'Product concept illustration'; }
      document.querySelectorAll('.thumb').forEach(el => el.setAttribute('aria-pressed', String(el === target)));
    }
    if (target.dataset.quantity) {
      selectedQuantity = Math.max(1, Math.min(MAX_PREVIEW_QUANTITY, selectedQuantity + (target.dataset.quantity === 'increase' ? 1 : -1)));
      const display = $('[data-product-quantity]'); if (display) display.textContent = String(selectedQuantity);
    }
    if (target.hasAttribute('data-add-preview')) {
      bagQuantity = Math.min(MAX_PREVIEW_QUANTITY, bagQuantity + selectedQuantity);
      renderBag(); say('Preview bag now contains ' + bagQuantity + ' four-piece set' + (bagQuantity === 1 ? '.' : 's.'));
      openDialog($('#preview-bag'), target);
    }
    if (target.dataset.bagChange) {
      bagQuantity = Math.max(0, Math.min(MAX_PREVIEW_QUANTITY, bagQuantity + (target.dataset.bagChange === 'increase' ? 1 : -1)));
      const action = target.dataset.bagChange;
      renderBag();
      say('Preview bag quantity: ' + bagQuantity);
      // Rendering replaces controls; restore keyboard focus to the equivalent button.
      ($('#preview-bag [data-bag-change="' + action + '"]') || $('#preview-bag [data-explore]'))?.focus();
    }
    if (target.hasAttribute('data-remove')) { bagQuantity = 0; renderBag(); say('Preview bag emptied.'); $('#preview-bag [data-explore]')?.focus(); }
    if (target.hasAttribute('data-explore')) {
      $('#preview-bag')?.close();
      const first = $('#first-find');
      if (first) first.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      else window.location.assign(document.body.dataset.homeUrl || '/');
    }
    if (target.dataset.info && info[target.dataset.info]) {
      const [title, ...paragraphs] = info[target.dataset.info];
      $('#information-title').textContent = title;
      const body = $('[data-information-body]'); body.replaceChildren();
      paragraphs.forEach(text => { const p = document.createElement('p'); p.textContent = text; body.appendChild(p); });
      if (target.dataset.info === 'contact') {
        const link = document.createElement('a');
        link.href = 'mailto:support@homethingsco.com.au';
        link.textContent = 'Email support@homethingsco.com.au';
        link.style.overflowWrap = 'anywhere';
        body.appendChild(link);
      }
      openDialog($('#information-dialog'), target);
    }
  });
  document.querySelectorAll('dialog').forEach(dialog => {
    dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
    dialog.addEventListener('close', () => { if (lastTrigger?.isConnected) lastTrigger.focus(); });
  });
  renderBag();
})();
